import Stepper from "@/components/Stepper/index.vue";
import { StepList } from "@/components/Stepper/parts/StepperHeader/StepperHeader.component";
import { Component, Vue } from "vue-property-decorator";
import Site from "@/components/Site/index.vue";
import SiteSettings from "@/components/SiteSettings/index.vue";
import Equipment from "@/components/Equipment/index.vue";
import BalanceSheet from "@/components/BalanceSheet/index.vue";
import { useVuelidate } from "@vuelidate/core";
import store from "@/store";
import AtInternet from "@/services/atInternet";


import { UPDATE_CURRENT_STEP } from "@/store/operators";
@Component({
  components: {
    Stepper,
    Site,
    SiteSettings,
    Equipment,
    BalanceSheet,
  },
  setup() {
    const v = useVuelidate();
    return { v: v };
  },
})
export default class AsbestosSitePage extends Vue {
  bus = new Vue();
  steps = [
    this.$t("components.stepperSite.firstStep"),
    this.$t("components.stepperSite.secondStep"),
    this.$t("components.stepperSite.thirdStep"),
    this.$t("components.stepperSite.fourthStep"),
  ];
  // atinternet = AtInternet;

  hasPrevious(): boolean {
    return this.currentStep > StepList.asbestos;
  }

  hasNext(): boolean {
    return this.currentStep < StepList.results;
  }

  get currentStep(): number {
    return store.state.globalAppDataModule.currentStep;
  }
  nextStep(): void {
    if (this.hasNext()) {
      AtInternet.pushDatalayer(this.currentStep );

      store.commit(UPDATE_CURRENT_STEP, this.currentStep + 1);
    }
    window.scrollTo(0, 0);
  }

  goBack(): void {
    if (this.currentStep > 0) {
      store.commit(UPDATE_CURRENT_STEP, this.currentStep - 1);
    }
    window.scrollTo(0, 0);
  }

  validate(): void {
    this.bus.$emit("validate");
    this.nextStep();
  }
}
